import { gql } from "@apollo/client";

export const LANGUAGES_QUERY = gql`
  query languages {
    languages {
      name
      code
      shortName
      culture
    }
  }
`;

export const PRIVACY_STATEMENT = gql`
  query webTemplate($code: String!, $languageCode: String) {
    webTemplate(code: $code, languageCode: $languageCode)
  }
`;
